import { render, staticRenderFns } from "./AIChatBubble.vue?vue&type=template&id=362879cc&scoped=true&"
import script from "./AIChatBubble.vue?vue&type=script&lang=js&"
export * from "./AIChatBubble.vue?vue&type=script&lang=js&"
import style0 from "./AIChatBubble.vue?vue&type=style&index=0&id=362879cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362879cc",
  null
  
)

export default component.exports